import { useSelector } from 'react-redux'
import { MobileFooter } from './MobileFooter'
import { PcFooter } from './PcFooter'
import { ScrollTop } from './ScrollTop'
import { RootState } from '@/stores'

export const Footer: React.FC = () => {
  const footer = useSelector((state: RootState) => state.footer)
  if (!footer.show) return null
  return (
    <>
      <ScrollTop />
      <footer>
        <MobileFooter />
        <PcFooter />
      </footer>
    </>
  )
}
